import { IonCard } from '@ionic/react';

import { RecordingTypeInDatabase } from '@/utils/getFirebaseRecordingTypesByIds';
import { mergeClassNames } from '@/utils/mergeClassNames';

import { useActiveSessionStore } from '@/hooks/useActiveSessionStore';

import { useAuthContext } from '@/contexts/authContext';

import styles from './RadioSelectButtonGroup.module.css';

import { MovementType } from '@/types/MovementTypes';

import { Icon, IconName } from '../Icon';

export interface RadioSelectButtonGroupProps {
  currentMovementType?: MovementType;
  onChange: (movementType: MovementType) => void;
}

export const RadioSelectButtonGroup = ({ currentMovementType, onChange }: RadioSelectButtonGroupProps) => {
  const { recordingTypes, setActiveTestId } = useActiveSessionStore();
  const role = useAuthContext().state.userState?.role;

  const getMovementTypeByTest = (test: RecordingTypeInDatabase) => {
    switch (test.name) {
      case 'Walking':
        return MovementType.walk;
      case 'Running':
        return MovementType.run;
      case 'Single Leg Squat':
        return MovementType.singleLegSquat;
      default:
        return MovementType.doubleLegSquat;
    }
  };

  const handleChange = (test: RecordingTypeInDatabase) => {
    const movementType = getMovementTypeByTest(test);
    if (!movementType) throw new Error('Invalid movement type');

    onChange(movementType);
    setActiveTestId(test.id);
  };

  const filteredRecordingTypes = recordingTypes.filter((test) => {
    const isSquat = test.name === 'Single Leg Squat' || test.name === 'Double Leg Squat';
    if (isSquat && role !== 'ORYX_Admin') {
      return false;
    }
    return true;
  });

  return (
    <div className={styles.options}>
      {filteredRecordingTypes.map((test) => {
        const movementType = getMovementTypeByTest(test);
        const isActive = movementType === currentMovementType;

        return (
          <IonCard
            button
            className={mergeClassNames(styles.option, isActive && styles.active)}
            key={test.id}
            onClick={() => handleChange(test)}>
            <div className={styles.content}>
              <Icon
                color={isActive ? 'var(--ion-color-teal600)' : '#CBE4AE'}
                height={35}
                name={test.icon as IconName}
                width={24}
              />
              {test.name}
            </div>
          </IonCard>
        );
      })}
    </div>
  );
};
